import { registerLocale } from 'react-datepicker';
import { Locale } from 'date-fns';

export const loadLocale: (locale: string) => {} = (locale: string): {} => {
  return import(`date-fns/locale/${locale}`).then((l: { default: Locale }): void => {
    registerLocale(locale, l.default);
  });
};
